import { Flex, ResourceList, Text, TextContainer } from "@wayflyer/flyui";
import type { ReactNode } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { useEmailVerificationResend } from "../../../hooks/email-verification";

import { MESSAGES } from "./message-definitions";

export interface ReviewScreenEmailVerificationProps {
  emailAddress: string;
}

export const ReviewScreenEmailVerification = ({ emailAddress }: ReviewScreenEmailVerificationProps) => {
  const intl = useIntl();
  const { sendVerificationEmail, isSending, recentlySent } = useEmailVerificationResend();
  const buttonDisabled = isSending || recentlySent;

  return (
    <Flex direction="column" gap="16">
      <TextContainer>
        <FormattedMessage
          id="funding-application: email verification details"
          defaultMessage="<p>To ensure the security of your account, we've sent a verification link to your registered email address. Please check your inbox and click on the link to complete the verification process.</p><p>Email verification is required to progress with your application.</p>"
          values={{
            p: (chunks: ReactNode[]) => <Text>{chunks}</Text>,
          }}
        />
      </TextContainer>
      <ResourceList.InlineActionItem
        label={intl.formatMessage(MESSAGES.emailVerificationStepTitle)}
        action={{
          responsiveFullWidth: true,
          onClick: sendVerificationEmail,
          label: intl.formatMessage(
            recentlySent ? MESSAGES.emailVerificationStepButtonSent : MESSAGES.emailVerificationStepButtonReSend
          ),
          disabled: buttonDisabled,
        }}
      >
        <FormattedMessage
          id="funding-application: verification email request hint"
          defaultMessage="<p>Please verify the email address you signed up with to continue: <b>{emailAddress}</b></p>"
          values={{
            p: (chunks: ReactNode[]) => <Text size="sm">{chunks}</Text>,
            b: (chunks: ReactNode[]) => <strong>{chunks}</strong>,
            emailAddress: emailAddress,
          }}
        />
      </ResourceList.InlineActionItem>
    </Flex>
  );
};
